import { useCallback, useEffect, useState } from 'react';
import { FormInstance } from 'antd/lib/form';

const checkHasErrors = (fieldsError: any[]) => fieldsError.some((val) => val.errors.length > 0);

interface Output {
    checkErrors: () => boolean;
    formReady: boolean;
}

// Use for initial validation to block the submit button
// Output a function to check for error & check if form is ready
export default function useFormCheckErrors(form: FormInstance, requiredFields: string[] = []): Output {
    const { getFieldsError, isFieldTouched, getFieldValue } = form;
    const [formReady, setFormReady] = useState(false);

    useEffect(() => {
        setFormReady(true);
    }, []);

    // When field been toggled, it will return isTouched false but value is string
    const allRequiredFieldsTouched = useCallback(
        () =>
            !requiredFields.some(
                (field) => !isFieldTouched(field) && (getFieldValue(field) === undefined || getFieldValue(field) === '')
            ),
        [requiredFields, isFieldTouched, getFieldValue]
    );

    const checkErrors = useCallback(() => {
        return formReady ? !allRequiredFieldsTouched() || checkHasErrors(getFieldsError()) : true;
    }, [formReady, getFieldsError, allRequiredFieldsTouched]);

    return {
        checkErrors,
        formReady,
    };
}
